export default __webpack_public_path__ + "static/media/moonpay_walkthrough_5.fbc50e2b.bin";